export enum TransactionType {
  IMPORT_TX = "IMPORT_TX",
  EXPORT_TX = "EXPORT_TX",
  ADD_VALIDATOR_TX = "ADD_VALIDATOR_TX",
  ADD_DELEGATOR_TX = "ADD_DELEGATOR_TX",
  ADVANCE_TIME_TX = "ADVANCE_TIME_TX",
  REWARD_TX = "REWARD_TX",
  ADD_PERMISSIONLESS_DELEGATOR_TX = "ADD_PERMISSIONLESS_DELEGATOR_TX",
  ADD_PERMISSIONLESS_VALIDATOR_TX = "ADD_PERMISSIONLESS_VALIDATOR_TX",
  BASE_TX = "BASE_TX",
  empty = "empty",
}

export enum InputOutputTransactionType {
  IMPORT = "IMPORT",
  TX = "TX",
  EXPORT = "EXPORT"
}

export enum QueryKey {
  address = "address",
  transaction = "transaction",
  transactionByInputId = "transactionByInputId",
  transactionList = "transactionList",
  importExportTransactionsList = "importExportTransactionsList",
  importExportTransactionByExportId = "importExportTransactionByExportId",
  ethAddress = "ethAddress",
  blocks = "blocks",
  transactionLength = "transactionLength",
  blockHeight = "blockHeight",
  balances = "balances",
  fundsHistory = "fundsHistory",
  pUtxo = "pUtxo",
  cUtxo = "cUtxo",
  networkData = "networkData",
  validatorList = "validatorList",
  nodes = "nodes",
  validator = "validator",
  node = "node",
  delegationsList = "delegationsList",
  uptimeEpoch = "uptimeEpoch",
  epochData = "epochData",
}
